import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SendLogin } from "../redux/auth";
import { connect, useDispatch } from "react-redux";

const LogActivity = (props) => {
  const location = useLocation();
  let isSessionActive = false;
  const isAuthenticated = props.authenticated || false;
  const dispatch = useDispatch();

  const invokeLoginApi = () => {
    isSessionActive = sessionStorage.getItem("userActivityLog") || false;
    if (!isSessionActive && isAuthenticated) {
      dispatch(SendLogin());
      sessionStorage.setItem("userActivityLog", true);
    }
  };

  useEffect(() => {
    invokeLoginApi();
  }, [location.pathname, isAuthenticated]);

  return null;
};

const mapStateToProps = ({ auth }) => ({
  ...auth,
});

export default connect(mapStateToProps, null)(LogActivity);
